import { mapState } from "vuex";
import featureFlags from "@/mixins/featureFlags";

export default {
  mixins: [featureFlags],
  computed: {
    backgroundClass() {
      // The gradient is chosen by feature-performx-logo, which is known as soon
      // as flags resolve. Whitelabel config does not affect this class (#191170).
      if (!this.featureFlagsResolved) return "";
      return this.isPerformxLogoEnabled() ? "background-lightened" : "gradient-background";
    },
    ...mapState(["featureFlagsResolved"]),
  },
};
